import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import root from './Redux/reducer';

/**
 * Redux store.
 *
 * Replaces `legacy_createStore` + manual `applyMiddleware(thunk)`, both deprecated.
 * configureStore wires the thunk middleware and the Redux DevTools connection itself.
 *
 * Note on `serializableCheck`: redux-persist dispatches internal actions carrying
 * non-serializable values (the rehydrate callbacks). They are ignored here rather than
 * disabling the check wholesale, so genuine non-serializable payloads in application
 * actions are still reported in development.
 */
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['common'],
};

const persistedReducer = persistReducer(persistConfig, root);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
    devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);
